// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"8ea8834a","66":"6fd603eb","287":"f3aa2224","572":"120a42d5","638":"64321fc3"}[chunkId] + ".chunk.js";
};